import { useCallback } from 'react';
import { fromEvent } from 'rxjs';
import type { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import useUnmount from './useUnmount';

const useFromEvent = (): ((
  target: Document | Window | HTMLElement,
  eventName: string
) => Observable<Event>) => {
  const unmount = useUnmount();

  return useCallback(
    (target: Document | Window | HTMLElement, eventName: string) =>
      fromEvent(target, eventName).pipe(takeUntil(unmount)),
    [unmount]
  );
};

export default useFromEvent;
